import imgOlga from '../../../assets/images/img_team_olga.webp';
import imgDima from '../../../assets/images/img_team_dima.webp';
import imgVika from '../../../assets/images/img_team_vika.webp';
import imgSvetlana from '../../../assets/images/img_team_svetlana.webp';
import imgMari from '../../../assets/images/img_team_mari.webp';
import imgAndrey from '../../../assets/images/img_team_andrey.webp';

const teams = [
    {
        id: 1,
        name: "Ольга Александровна Романова",
        imgUrl: imgOlga,
        speciality: "Стоматолог- имплантолог, ортопед",
        specialization: "Челюстно-лицевая хирургия, дентальная имплантология, протезирование, эстетическая стоматология.",
        education: "Алма-Атинчкий Государственный Медицинский Институт (1986 г) (диплом с отличием)",
        experience: "более 30 лет",
        improvements: "Неоднократно проходил курсы повышения квалификации, а также мастер-классы от профессоров мировой величины.",
        receptionTime: "Пн-Пт, 10:00 - 19:00",
    },
    {
        id: 2,
        name: "Щеголев Дмитрий Владиславович",
        imgUrl: imgDima,
        speciality: "Стоматолог- имплантолог, ортопед",
        specialization: "Челюстно-лицевая хирургия, дентальная имплантология, протезирование, эстетическая стоматология.",
        education: "Алма-Атинчкий Государственный Медицинский Институт (1986 г) (диплом с отличием)",
        experience: "более 30 лет",
        improvements: "Неоднократно проходил курсы повышения квалификации, а также мастер-классы от профессоров мировой величины.",
        receptionTime: "Пн-Пт, 10:00 - 19:00",
    },
    {
        id: 3,
        name: "Виктория Евгеньевна Соловьёва",
        imgUrl: imgVika,
        speciality: "Стоматолог- имплантолог, ортопед",
        specialization: "Челюстно-лицевая хирургия, дентальная имплантология, протезирование, эстетическая стоматология.",
        education: "Алма-Атинчкий Государственный Медицинский Институт (1986 г) (диплом с отличием)",
        experience: "более 30 лет",
        improvements: "Неоднократно проходил курсы повышения квалификации, а также мастер-классы от профессоров мировой величины.",
        receptionTime: "Пн-Пт, 10:00 - 19:00",
    },
    {
        id: 4,
        name: " Нейман Светлана Владимировна",
        imgUrl: imgSvetlana,
        speciality: "Стоматолог- имплантолог, ортопед",
        specialization: "Челюстно-лицевая хирургия, дентальная имплантология, протезирование, эстетическая стоматология.",
        education: "Алма-Атинчкий Государственный Медицинский Институт (1986 г) (диплом с отличием)",
        experience: "более 30 лет",
        improvements: "Неоднократно проходил курсы повышения квалификации, а также мастер-классы от профессоров мировой величины.",
        receptionTime: "Пн-Пт, 10:00 - 19:00",
    },
    {
        id: 5,
        name: "Мария Вадимовна Жадан",
        imgUrl: imgMari,
        speciality: "Стоматолог- имплантолог, ортопед",
        specialization: "Челюстно-лицевая хирургия, дентальная имплантология, протезирование, эстетическая стоматология.",
        education: "Алма-Атинчкий Государственный Медицинский Институт (1986 г) (диплом с отличием)",
        experience: "более 30 лет",
        improvements: "Неоднократно проходил курсы повышения квалификации, а также мастер-классы от профессоров мировой величины.",
        receptionTime: "Пн-Пт, 10:00 - 19:00",
    },
    {
        id: 6,
        name: "Андрей Иванович Петров",
        imgUrl: imgAndrey,
        speciality: "Стоматолог- имплантолог, ортопед",
        specialization: "Челюстно-лицевая хирургия, дентальная имплантология, протезирование, эстетическая стоматология.",
        education: "Алма-Атинчкий Государственный Медицинский Институт (1986 г) (диплом с отличием)",
        experience: "более 30 лет",
        improvements: "Неоднократно проходил курсы повышения квалификации, а также мастер-классы от профессоров мировой величины.",
        receptionTime: "Пн-Пт, 10:00 - 19:00",
    }
]
export default teams;